/*global require: false */
require(['jquery'],
    function ($) {
        'use strict';

        $(document).ready(function () {
            var value = $('#SelectedValue').val()
            if (value === 'Other') {

                $('#Othertext').removeClass('hide');
                $('#Othertextfield').prop('required', true);
            }
            else {
                $('#Othertext').addClass('hide');
                $('#Othertextfield').prop('required', false);
                $('#Othertextfield').val('');
            }

            if (value !== 'Myself' && value !== '') {
                $('#NameandPhone').removeClass('hide');
                $('#OtheNamefield').prop('required', true);
            }
            else {
                $('#NameandPhone').addClass('hide');
                $('#OtheNamefield').prop('required', false);
                $('#OtheNamefield').val('');
            }

            $('#SelectedValue').change(function () {
                var value = $('#SelectedValue').val()
                if (value === 'Other') {

                    $('#Othertext').removeClass('hide');
                    $('#Othertextfield').prop('required', true);
                }
                else {
                    $('#Othertext').addClass('hide');
                    $('#Othertextfield').prop('required', false);
                    $('#Othertextfield').val('');
                }

                if (value !== 'Myself' && value !== '') {
                    $('#NameandPhone').removeClass('hide');
                    $('#OtheNamefield').prop('required', true);
                }
                else {
                    $('#NameandPhone').addClass('hide');
                    $('#OtheNamefield').prop('required', false);
                    $('#OtheNamefield').val('');
                }
            });

            if ($('#HealthCareYes:checked').val() === 'YES') {
                $('#HealthInfo').removeClass('hide');
            }
            else {
                $('#HealthInfo').addClass('hide');
            }

            if ($('#DoctorPrescriptionsYes:checked').val() === 'YES') {
                $('#Medications').removeClass('hide');
            }
            else {
                $('#Medications').addClass('hide');
            }

            function toggleAndClear(mainCheckboxId, subContainerId, textInputId) {
                const mainCheckbox = $('#' + mainCheckboxId);
                const subContainer = $('#' + subContainerId);
                const textInput = $('#' + textInputId);

                mainCheckbox.change(function () {
                    subContainer.toggle(this.checked);
                    if (!this.checked) {
                        subContainer.find('input[type="checkbox"]').prop('checked', false);
                        if (textInput.length) {
                            textInput.val('');
                        }
                    }
                });
                mainCheckbox.trigger('change');
            }
            // Apply to each main category
            toggleAndClear('AmericanIndianAlaskaNative', 'americanIndianSpecify', 'AmericanIndianOther');
            toggleAndClear('Asian', 'asianSubcategories', 'AsianOther');
            toggleAndClear('BlackAfricanAmerican', 'blackSubcategories', 'BlackAfricanAmericanAfrOther');
            toggleAndClear('HispanicLatino', 'hispanicSubcatagories', 'HispanicLatinoOther');
            toggleAndClear('MiddleEastern', 'middleEasternSubcatagories', 'MiddleEasternOther');
            toggleAndClear('NativeHawaiian', 'nativeHawaiianSubcatagories', 'NativeHawaiianOther');
            toggleAndClear('White', 'whiteSubcatagories', 'WhiteOther');
        });

        $('#HealthCare').change(function () {
            if ($('#HealthCareYes:checked').val() === 'YES') {
                $('#HealthInfo').removeClass('hide');
            }
            else {
                $('#HealthInfo').addClass('hide');
            }
        });
        $('#DoctorPrescriptions').change(function () {
            if ($('#DoctorPrescriptionsYes:checked').val() === 'YES') {
                $('#Medications').removeClass('hide');
            }
            else {
                $('#Medications').addClass('hide');
            }
        });

    });
define("health-needs-survey", function(){});

